module.exports = __webpack_public_path__ + "assets/img/65a48cdd158f7efea901a210729c5f2b.png";